import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { APIConfiguration } from '@savgroup-front-common/configuration';
import { MIME_TYPES } from '@savgroup-front-common/constants';

import { CommonAttachmentService, CommonWorkflowService } from '../api';
import { toast } from '../atoms/Toast';
import { attachmentsListOrigins } from '../domains/attachments';
import { loadFilesAttachmentList } from '../domains/attachments/actionCreators';
import { globalMessages } from '../helpers';

interface UseUploadDocumentsArgs {
  fileId?: string;
}

export const useUploadAttachmentsOnFile = ({
  fileId,
}: UseUploadDocumentsArgs) => {
  const dispatch = useDispatch();

  const handleUploadDocuments = useCallback(
    async ({ files }: { files: File[] }) => {
      if (!fileId) {
        return;
      }

      await Promise.all(
        files.map(async (file) => {
          const uploadResponse =
            await CommonAttachmentService.uploadAttachements<string>({
              files: [file],
              endpoint: `${APIConfiguration.document}files/${fileId}/control-attachments`,
            });

          const mimeType = file.type || MIME_TYPES.OCTET_STREAM;
          const { name } = file;

          const extension = mimeType.substring(mimeType.indexOf('/') + 1);

          if (uploadResponse.failure) {
            toast.error(globalMessages.documentMessages.documentImportFail);

            return;
          }
          const setFileResponse =
            await CommonWorkflowService.setFileAttachmentInfo({
              fileId,
              extension,
              name,
              fileAttachmentId: uploadResponse.value,
            });

          if (setFileResponse.failure) {
            toast.error(globalMessages.documentMessages.documentImportFail);
          }
        }),
      );
      dispatch(
        loadFilesAttachmentList({
          fileId,
          type: attachmentsListOrigins.CONTROL,
        }),
      );
    },
    [fileId, dispatch],
  );

  return { handleUploadDocuments };
};
